// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deepMergeKeepExistingIfEmpty(target: any, source: any) {
  const result = Array.isArray(target) ? [...target] : { ...target };
  if (!source || typeof source !== 'object') return result;
  for (const key of Object.keys(source)) {
    const newValue = source[key];
    const oldValue = result[key];
    const isObject =
      newValue && typeof newValue === 'object' && !Array.isArray(newValue);
    if (isObject) {
      result[key] = deepMergeKeepExistingIfEmpty(oldValue || {}, newValue);
    } else {
      if (newValue !== null && newValue !== undefined && newValue !== '') {
        result[key] = newValue;
      } else {
        result[key] = oldValue;
      }
    }
  }
  return result;
}

// 与 deepMergeKeepExistingIfEmpty 相同，但 overrideKeys 里的字段直接取 source 的值整体覆盖，
// 不做深合并。用于 protobuf 的 "one-of"（联合）字段：target 自带一个默认分支，若把导入的分支
// 深合并上去会导致两个分支同时存在，产生非法的数据。
export function deepMergeOverriding(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  target: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  source: any,
  overrideKeys: string[]
) {
  const result = deepMergeKeepExistingIfEmpty(target, source);
  for (const key of overrideKeys) {
    if (source?.[key] != null) {
      result[key] = source[key];
    }
  }
  return result;
}
